import { PDFViewer } from "@react-pdf/renderer"
import TasimaSenediPDF from "../../pdf/TasımaSenediPDF";
import { useSelector } from "react-redux";

const JobListPDFViewer = () => {

    const { mektupData } = useSelector(state => state.jobList);

    
  return (
    <div>
        <PDFViewer width="100%" height="500px">
            <TasimaSenediPDF data={mektupData} />
        </PDFViewer>
    </div>
  )
}

export default JobListPDFViewer